import { Building, Hammer, ClipboardList, Users, Building2, DraftingCompass, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    icon: Building,
    title: "Extensions & Refurbishments",
    text: "Transform and expand your property with professionally managed extension and refurbishment projects.",
  },
  {
    icon: Hammer,
    title: "Renovations & Conversions",
    text: "Complete property transformations, renovations and conversions designed around your requirements.",
  },
  {
    icon: ClipboardList,
    title: "Project Management",
    text: "End-to-end coordination of trades, materials, schedules and contractors.",
  },
  {
    icon: Users,
    title: "Subcontracting",
    text: "Reliable access to trusted specialist trades and construction professionals.",
  },
  {
    icon: Building2,
    title: "New Builds & Developments",
    text: "Construction support for new-build properties and development projects.",
  },
  {
    icon: DraftingCompass,
    title: "Planning & Development Support",
    text: "Practical support from initial concept through planning, construction and completion.",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative bg-[#0A111E] py-24 sm:py-32">
    <div className="pointer-events-none absolute inset-0 architectural-grid opacity-40" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16 max-w-2xl">
        <div className="mb-6 flex items-center gap-4">
          <span className="h-px w-12 bg-gradient-to-r from-[#C5A059] to-transparent" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">What We Do</span>
        </div>
        <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
          Services Built on <span className="gold-text-gradient">Precision.</span>
        </h2>
      </Reveal>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.12}>
            <button
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => scrollToId("#contact")}
              className="group relative flex h-full w-full flex-col border border-[#C5A059]/20 bg-[#0E1726]/80 p-8 text-left transition-all duration-500 hover:-translate-y-1.5 hover:border-[#C5A059] hover:bg-[#0E1726] hover:shadow-[0_0_35px_rgba(197,160,89,0.18)]"
            >
              <span className="absolute right-6 top-6 font-mono text-xs text-[#C5A059]/40 transition-colors duration-500 group-hover:text-[#C5A059]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex h-14 w-14 items-center justify-center border border-[#C5A059]/30 transition-all duration-500 group-hover:border-[#C5A059] group-hover:bg-[#C5A059]/10">
                <s.icon size={26} strokeWidth={1.25} className="text-[#C5A059]" />
              </span>
              <h3 className="mt-7 font-serif text-xl font-medium uppercase tracking-wide text-white sm:text-2xl">
                {s.title}
              </h3>
              <p className="mt-4 flex-1 text-sm font-light leading-relaxed text-slate-400">{s.text}</p>
              <span className="mt-7 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#C5A059]/0 transition-all duration-500 group-hover:text-[#C5A059]">
                Enquire <ArrowUpRight size={14} />
              </span>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
